import { withSuspenseLazy } from 'react-with-suspense-lazy';

import { Loader } from '@components/Loader';
import { RoutesConfiguration } from '@components/RouterOutlet';
import { permissionsRoles } from '@config/permissions';
import { ProfileRoutePaths } from '@routes/routesPaths';

const Profile = withSuspenseLazy(
  () => import('./ProfilePage'),
  Loader,
);

export const ProfileRouteConfig: RoutesConfiguration = [
  {
    path: ProfileRoutePaths.profileRoot,
    component: Profile,
    permittedRoles: permissionsRoles.profile,
  },
];
